import _ from 'lodash';
import service from './service';
import { SORT_ORDER } from '@/resources/Constants'
import { getGridPagingParams, mapGridPagingState } from '../../shared/utils';

const DEFAULT_SORT_ORDER = SORT_ORDER.ASC;

const state = {
    cases: [],
    casePaging: {
        ...getGridPagingParams(DEFAULT_SORT_ORDER, 'caseName'),
        filters: {}
    },
    caseStatus: [],
    channels: [],
}

const getters = {};

const actions = {
    async getCaseStatus({ commit }) {
        const results = await service.getCaseStatus();

        commit('setCaseStatus', results);
    },

    async getChannels({ commit }) {
        const results = await service.getChannels();

        commit('setChannels', results);
    },

    async getCasesList({ commit, state },
        {
            pageNumber = state.casePaging.pageNumber,
            pageSize = state.casePaging.pageSize,
            sortBy = state.casePaging.sortBy,
            sortOrder = state.casePaging.sortOrder,
            filters = state.casePaging.filters,
        } = {}) {

        const results = await service.getCases(
            pageNumber,
            pageSize,
            sortOrder,
            sortBy,
            filters
        );

        commit('setCasesList', results);
    },

}

const mutations = {
    setCaseStatus(state, payload) {
        state.caseStatus = payload && payload.length > 0 ? payload : [];
    },

    setChannels(state, payload) {
        state.channels = payload && payload.length > 0 ? payload : [];
    },

    setCasesList(state, payload) {
        const pagingData = payload && payload.paging;

        state.cases = payload && payload.items;

        if (pagingData) {
            state.casePaging = mapGridPagingState(
                state.casePaging,
                pagingData
            );
        }

    },
}


const cases = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default cases;